import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ChangeGesturePageRoutingModule } from './change-gesture-routing.module';

import { ChangeGesturePage } from './change-gesture.page';
import {SharedModule} from '../../../shared/shared.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ChangeGesturePageRoutingModule,
        SharedModule
    ],
  declarations: [ChangeGesturePage]
})
export class ChangeGesturePageModule {}
